export default {
  isLoggedIn: state => !!state.user,

  currentEpisode: state => {
    if (!state.user) {
      return 0
    }
    const matches = state.user.email.match(/@episode(\d).com/)

    const episode = matches && matches.length > 1 ? Number(matches[1]) : 1

    return episode || 1
  },

  username: state => {
    if (!state.user) {
      return ''
    }
    return state.user.email
      .split('@')[0]
      .replace('-encrypted', '')
      .toUpperCase()
  },
}
